export default "__VITE_ASSET__DNgOqV7J__"